import { h } from 'preact'

/**
 * PresenceDot — a small colored circle indicating online/offline status.
 *
 * Props: { personId, store, size }
 *   size: "sm" (default) | "md"
 *
 * Reads store.presenceMap.value[personId]?.online
 */
export function PresenceDot({ personId, store, size = 'sm' }) {
  if (!personId) return null

  const presence = store.presenceMap.value[personId]
  const online   = presence?.online ?? false

  return (
    <span
      class={`chat-presence-dot chat-presence-dot--${size} ${online ? 'chat-presence-dot--online' : 'chat-presence-dot--offline'}`}
      title={online ? 'Online' : 'Offline'}
    />
  )
}
